import React from "react";

function TextField({ id, label, ...rest }) {
  return (
    <div className="fieldContainer">
      <label>{label}</label>
      <input id={id} name={id} className="p-2" {...rest}></input>
    </div>
  );
}

export default TextField;
